module.exports = __webpack_public_path__ + "static/img/2.8c95a4ad.jpg";